// extracted by mini-css-extract-plugin
export default {"globusIcon":"style_globusIcon__0Xmnq"};